export const enum ETipoDemanda {
  'NovaContratacao' = 1,
  'Aditivo' = 2,
  'AcordodeFornecimento' = 3,
  'FaturamentoDireto' = 4,
  'AditivoFaturamentoDireto' = 5,
}
